/*
 * @Description: 
 * @Author: xutao
 * @Date: 2021-02-02 16:51:07
 * @LastEditors: xutao
 * @LastEditTime: 2021-02-02 16:52:22
 */
export const USER_FLAG = {
  /**
     * 已绑定手机号
     */
  HAS_PHONE: 1,
  /**
     * 未绑定手机号
     */
  NO_PHONE: 2
}
